import React from 'react'
import { Icon } from 'semantic-ui-react'

const CopyIcon = (props) => {
  const { value } = props;

  const copyToClipboard = (evt) => {
    evt.stopPropagation();
    navigator.clipboard.writeText(value);
  }

  return (
    <Icon name='copy outline' onClick={copyToClipboard}/>
  )
}

export default CopyIcon



// WEBPACK FOOTER //
// ./src/views/components/copy_icon.js